import { IApiJsonResponse } from '../../../__core/Interfaces/IApiResponse';
import { ICourse } from '../../../__core/Interfaces/ICourse';
import { IAction } from '../../../__core/Interfaces/IAction';
import COURSE_ACTIONS from './ActionTypes';
import { ICourseInstance } from '../../../__core/Interfaces/ICourseInstance';
import { CourseProgressResponse } from '../Types/CourseProgressResponse';
import { IEvent } from '../../../__core/Interfaces/IEvent';

export const getCourseDetailsSuccess = (
  courseInstanceDetails: IApiJsonResponse<ICourse>
): IAction<IApiJsonResponse<ICourse>> => ({
  type: COURSE_ACTIONS.FETCH_COURSE_DETAILS,
  payload: courseInstanceDetails,
});

export const getCourseInstanceSuccess = (
  courseInstance: IApiJsonResponse<ICourseInstance>
): IAction<IApiJsonResponse<ICourseInstance>> => ({
  type: COURSE_ACTIONS.FETCH_COURSE_INSTANCE,
  payload: courseInstance,
});

export const getCourseProgressSuccess = (
  courseResults: CourseProgressResponse
): IAction<CourseProgressResponse> => ({
  type: COURSE_ACTIONS.FETCH_COURSE_PROGRESS,
  payload: courseResults,
});

export const clearCourseDetails = (): IEvent => ({
  type: COURSE_ACTIONS.CLEAR_COURSE_DETAILS,
});
